(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  // Reveal complete ZAYN sections as they enter the viewport. The content stays
  // visible if JS is unavailable, and reduced-motion users get no animation.
  var sections = document.querySelectorAll('#MainContent .zayn');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    sections.forEach(function (section) {
      section.setAttribute('data-zayn-reveal', '');
      requestAnimationFrame(function () {
        section.setAttribute('data-zayn-ready', '');
      });
    });

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-zayn-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    sections.forEach(function (section) { observer.observe(section); });
  }

  // Keep the mobile purchase bar useful, quiet and non-sticky at the top of the page.
  var sticky = document.querySelector('[data-zayn-mobile-purchase]');
  if (sticky && !reduceMotion) {
    var threshold = 520;
    var ticking = false;
    function updateSticky() {
      sticky.classList.toggle('is-visible', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateSticky);
        ticking = true;
      }
    }, { passive: true });
    updateSticky();
  }
})();
